<template>
  <div class="pwa-widget-edit">
    <div class="tip">
      <span>使用PWA功能，用户可以将网页应用安装至桌面，方便其快速访问。应用图标使用 SEO图标。</span>
    </div>
    <menu-item label="移动端描述图片">
      <menu-background-image :target="model.guidBackground" target-key="guidBackground" event-key="pwa-guid-image" />
    </menu-item>
  </div>
</template>

<script>
import MenuItem from "~/components/menu/menuItem.vue";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue";

export default {
  components: {MenuBackgroundImage, MenuItem},
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  }
}
</script>



<style scoped lang="less">

</style>
